// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__38YZ1","domainDashboard":"styles_domainDashboard__3m0w7","copyButton":"styles_copyButton__3S7xh"};